import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { EFeatureToggles } from '../configurations/common';
import { map } from 'rxjs/operators';

export const externalQuoteCheckoutRouteGuard: CanActivateFn = (_route, _state) => {
  const configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);
  const router: Router = inject(Router);

  return configurationFacade.isFeatureEnabled(EFeatureToggles.EXTERNAL_QUOTE_CHECKOUT).pipe(
    map((isEnabled: boolean) => {
      if (isEnabled) {
        router.navigate(['/']);
        return false;
      }
      return true;
    })
  );
};
